namespace advisorop.components.servicer {
    
    class CompanyGroupCrudController {

        $router;
        lovs: Array<domains.ILOV> = [];
        selFirmType;
        showMappingPanel: boolean = false;
        model: domains.ICompanyGroup;
        updatingAccountLadda: boolean = false;
        streetAddressSameAsMailingAddress: boolean = false;
        flagForZipField: boolean = false;
        states: domains.ILOV[] = [];
        countries: domains.ILOV[] = [];
        usCountryCode: string = "US";
        selStreetState: domains.ILOV;
        selMailingState: domains.ILOV;
        selStreetCountry: domains.ILOV;
        selMailingCountry: domains.ILOV;

        
        static $inject = ["generalService","identityService","servicerService"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {
            this.model = {};
        }

        loadTestData(): void {
            /////////////////////////
            //test data ....
            this.model.streetCity = "Test City";
            this.model.companyName = "Test company";
            this.model.contactEmail = "fehimdev@gmail.com";
            this.model.contactFirstName = "First name";
            this.model.contactLastName = "Last name";
            this.model.contactPhone = "00999888";
            this.model.streetCountryId = "US";
            this.model.streetPostCode = "XB99992";
            this.model.streetState = "WA";
            this.model.streetAddress1 = "NA";
       
        };

        validateCompanyGroupForm(): boolean {
            if (!this.model.contactPhone || this.model.contactPhone.length != 10) {
                toastr.warning("Please provide 10-digit phone number.");
                return false;
            }
            if (isNaN(Number(this.model.contactPhone))) {
                toastr.warning("Phone number must consist of all numbers.");
                return false;
            }
            return true;
        };

        createCompanyGroup(): void {
            if (!this.validateCompanyGroupForm()) {
                return;
            }

            let r = this.$router;
            this.updatingAccountLadda = true;

            this.model.streetAddressSameAsMailingAddress = this.streetAddressSameAsMailingAddress;

            this.servicerService.createCompanyGroup(this.model)
                .then((data) => {
                    toastr.success("Company Group successfully saved.");
                    this.$router.navigate(["Dashboard"]);
                })
                .catch(error => {
                    toastr.error("Company Group was not saved! " + error.status + " : " + error.data);
                }).
                finally(() => {
                    this.updatingAccountLadda = false;
                });
        }

        loadCompanyGroup(id: number): void {
            this.servicerService.getCompanyGroup(id).then((data) => {
                this.model = data.data;
                this.selStreetState = <domains.ILOV>{ extra1: this.model.streetState };
                this.selMailingState = <domains.ILOV>{ extra1: this.model.mailingState };
                this.selStreetCountry = <domains.ILOV>{ extra2: this.model.streetCountryId };
                this.selMailingCountry = <domains.ILOV>{ extra2: this.model.mailingCountryId };
                this.streetAddressSameAsMailingAddress = this.model.streetAddressSameAsMailingAddress;
            });
        }

        streetAddressChanged(): void {
            if (this.selStreetState)
                this.model.streetState = this.selStreetState.extra1;
            if (this.selStreetCountry)
                this.model.streetCountryId = this.selStreetCountry.extra2;
            if (this.streetAddressSameAsMailingAddress == true) {
                this.selMailingCountry = this.selStreetCountry;
                this.selMailingState = this.selStreetState;
                this.model.mailingAddress1 = this.model.streetAddress1;
                this.model.mailingAddress2 = this.model.streetAddress2;
                this.model.mailingCity = this.model.streetCity;
                this.model.mailingPostCode = this.model.streetPostCode
                this.model.mailingState = this.model.streetState;
                this.model.mailingCountryId = this.model.streetCountryId;
            } else {
                if (this.selMailingState)
                    this.model.mailingState = this.selMailingState.extra1;
                if (this.selMailingCountry)
                    this.model.mailingCountryId = this.selMailingCountry.extra2;
            }
        }

        equalsAddresses(): void {
            this.streetAddressSameAsMailingAddress = !this.streetAddressSameAsMailingAddress;
            this.flagForZipField = !this.flagForZipField;
            this.selMailingCountry = this.selStreetCountry;
            this.selMailingState = this.selStreetState;
            this.model.mailingAddress1 = this.model.streetAddress1;
            this.model.mailingAddress2 = this.model.streetAddress2;
            this.model.mailingCity = this.model.streetCity;
            this.model.mailingCountryId = this.model.streetCountryId;
            this.model.mailingPostCode = this.model.streetPostCode
            this.model.mailingState = this.model.streetState;
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;
                    this.states = this.lovs.filter(v => v.lovType === domains.LovType.STATES);
                    this.countries = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        logout(): void {
            this.identityService.logout();
        }

        $onInit(): void {
            this.loadLovs();
            //this.loadCompanyGroupList();
        }
      

        $routerOnActivate(next, previous) {
            if (next.params.id)
            {
                this.loadCompanyGroup(<number>next.params.id);
            }
        }
    }

    class CompanyGroupCrud implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = CompanyGroupCrudController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/company-group-crud.html';            
        }
    }
    angular.module(Constants.APP).component("companyGroupCrud", new CompanyGroupCrud());
}